import { CheckCircle, Close, Error } from '@mui/icons-material';
import {
  Dialog,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent,
  Grid,
  SvgIcon,
  Box,
  styled,
  Button,
} from '@mui/material';
import React from 'react';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    height: '50vh',
  },
}));

const MODAL_TYPES = {
  ERROR: 'error',
  success: 'success',
};

export const Modal = ({
  type = MODAL_TYPES.success,
  open,
  onClose,
  message = '',
  onClick = () => {},
  enableBtn = false,
}) => {
  return (
    <StyledDialog open={open} fullWidth>
      <DialogTitle>
        <Box display="flex" flexDirection="row" alignItems="center">
          <IconButton
            data-testid="close-icon"
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Box>
        <Grid item></Grid>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
        }}
      >
        <SvgIcon
          color={type === MODAL_TYPES.success ? 'success' : 'error'}
          sx={{ fontSize: '100px' }}
          component={type === MODAL_TYPES.success ? CheckCircle : Error}
        ></SvgIcon>
        <Typography
          variant="subtitle1"
          sx={{ fontSize: '20px', textAlign: 'center' }}
        >
          {message}
        </Typography>
        {enableBtn && (
          <Button
            data-testid="ok-button"
            variant="contained"
            sx={{ margin: '5px 0 5px 0' }}
            onClick={onClick}
          >
            OK
          </Button>
        )}
      </DialogContent>
    </StyledDialog>
  );
};
